import React from 'react';
import { heroData } from '../data/mock';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const scrollToCollections = () => {
    const element = document.getElementById('collections');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroData.image}
          alt="Motherstore Paris"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-white mb-6 tracking-tight animate-fade-in">
          {heroData.title}
        </h1>
        <p className="text-xl sm:text-2xl lg:text-3xl text-white/90 mb-4 font-light tracking-wide">
          {heroData.subtitle}
        </p>
        <p className="text-base sm:text-lg text-white/80 mb-12 max-w-2xl mx-auto leading-relaxed">
          {heroData.description}
        </p>
        <Button
          onClick={scrollToCollections}
          className="bg-rose-400 hover:bg-rose-500 text-white px-8 py-6 text-base uppercase tracking-wider font-medium rounded-sm transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Découvrir nos Collections
        </Button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white/70" size={32} />
      </div>
    </section>
  );
};

export default HeroSection;
